module.exports = __webpack_public_path__ + "img/LOGOS.df13d96d.png";